import { ref, watch } from 'vue'
import { useWorkspacesTokensStore } from '@/stores/workspaces_tokens.store'

export default function useList(workspaceId) {
  const listTable = ref([])

  // Table Handlers
  const tableColumns = [
    { text: 'Name', value: 'name' },
    { text: 'Category', value: 'category' },
    { text: 'Key', value: 'secret' },
    { text: 'Required', value: 'mandatory' },
    { text: 'Type', value: 'type' },
    { text: 'UpdatedAt', value: 'updated_at' },
    {
      text: 'Action',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]

  const searchQuery = ref('')
  const options = ref({
    sortBy: ['name'],
    sortDesc: [false, true],
    itemsPerPage: 20,
  })
  const totalListTable = ref(0)
  const loading = ref(false)
  const selectedTableData = ref([])
  const isAddDialogVisible = ref(false)
  const isDeleteDialogVisible = ref(false)
  const tokensStore = useWorkspacesTokensStore()

  const fetchDatas = () => {
    loading.value = true
    tokensStore
      .getTokens({ workspaceId, search: searchQuery.value, options: options.value })
      .then(data => {
        listTable.value = data.data
        totalListTable.value = data.count
        loading.value = false
      })
      .catch(() => {
        listTable.value = []
        totalListTable.value = 0
        loading.value = false
      })
  }

  watch([searchQuery, options, isAddDialogVisible, isDeleteDialogVisible], () => {
    loading.value = true
    selectedTableData.value = []
    fetchDatas()
  })

  tokensStore.$subscribe(mutation => {
    if (mutation.payload) {
      const index = listTable.value.findIndex(it => it.id === mutation.payload.item.id)
      if (mutation.payload.eventType === 'UPDATE') {
        if (index !== -1) listTable.value.splice(index, 1, mutation.payload.item)
      } else if (mutation.payload.eventType === 'INSERT') {
        if (index === -1) listTable.value.splice(0, 0, mutation.payload.item)
        else listTable.value.splice(index, 1, mutation.payload.item)
      } else if (mutation.payload.eventType === 'DELETE') {
        if (index !== -1) listTable.value.splice(index, 1)
      }
    }
  })

  return {
    tableColumns,
    searchQuery,
    options,
    listTable,
    totalListTable,
    loading,
    selectedTableData,
    fetchDatas,
    isAddDialogVisible,
    isDeleteDialogVisible,
  }
}
